import { Box, IconButton, TextField, Button, Typography, Checkbox, Card, CardContent, Dialog, Tabs  } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
import { get, post } from "api/apiBridges/httpBridge";
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { useLocalNotifications } from "components/Events";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { SocketContext } from "components/socketLib/ConnectorSocket";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { SelectMarketLocal } from "components/SelectMarket";
import { colors } from "styles/colors";
import usePreventDoubleClick from "components/AntiDBC";
import { useNavigate } from "react-router-dom";
import { useDataContextDeal } from "actions/contextDealClient";
import ClassicSearch from "components/classicSearch";
import { DealTab, StyledTab } from "utils/formatters";
import { TabPanel } from "components/tabPanel";
import { sortProducts } from "utils/globalSorts";


export function ClientsRSRDs() {
    const [tab, setTab] = useState(undefined);
    
    const [info, setInfo] = useState(undefined)
    const [search, setSearch] = useState(undefined)
    const [buttons, setButtons] = useState(undefined)
    // @ts-ignore
    const handleChange = (event, newTab) => {
        setTab(newTab);
        sessionStorage.setItem(`RSRDTAB`, newTab)
    };
    useEffect(() => {
        handleChange(undefined, Number(sessionStorage.getItem(`RSRDTAB`)) || 0)
    }, []);

    return (

        <Box sx={{ width: '100%', height: '100%'}}>
            <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    height: "5%", 
                    margin: "10px 1% 10px 1%"
                }}
            >
                {search || <div></div>}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '10px',
                    }}>
                        {!info? 
                            <Loading/>
                        :
                            info
                        }
                    </Box>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginLeft: "10px" }}>
                        {buttons}
                    </div>
                </div>
            </div>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                margin: '0% 0% 0% 1%',
                height: "30px",
                minHeight: "30px"
            }}>
                <DealTab label="ВОЗВРАТЫ" />
                <DealTab label="САМОВЫКУП" />
                <DealTab label="БРАК" />
            </Tabs>
            <TabPanel value={0} select={tab}>
                <ClientsReturns type={'returns'} setInfo={setInfo} setButtons={setButtons}/>
            </TabPanel>
            <TabPanel value={1} select={tab}>
                <ClientsReturns type={'selfreturns'} setInfo={setInfo} setButtons={setButtons}/>
            </TabPanel>
            <TabPanel value={2} select={tab} >
                <ClientsDefects setInfo={setInfo} setButtons={setButtons}/>
            </TabPanel>

        </Box>
    );
}


export function ClientsDefects({setInfo, setButtons}) {
    const ds = useMemo(() => getDataSource('ClientsDefects'), []);
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    const [totalUnits, setTotalUnits] = useState(0);
    const { market } = useSelector(MarketClientSelector);
    const [loading, setLoading] = useState(false);

    const { socket } = useContext(SocketContext);

    const { showNotification } = useLocalNotifications();

    const { company_id, user_id  } = useSelector(
        loginSelector
    );

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 10px'}}>
                        SKU: {data.length}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Кол-во: <Typography component="span" sx={{ fontSize: '12pt', color: 'inherit' }}>{totalUnits} шт.</Typography>
                    </Typography>
                </>
            )
        }
        setInfo(getInfo())
    }, [data, totalUnits]);

    useEffect(() => {
        const getButtons = () => {
            return (
                <Button 
                    variant="contained" 
                    onClick={(e) => {getMeMyDefects()}} 
                    sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: "10px" }}
                    disabled={data.length === 0}
                >
                    Забрать
                </Button>
            )
        }
        setButtons(getButtons())
    }, [data]);

    const fetchData = async () => {
        try {
            setLoading(true)
            let products = await get("Deal/getDefectProducts", {cid: user_id, market})
            let res = []
            let c = 0
            products.map((el) => {
                c += el.countProduct
                el.data = {
                    vendorCode:el.vendorCode,
                    brand:el.brand,
                    title:el.title,
                    photo:el.photo,
                    nmID:el.nmID,
                    color:el.color,
                    sizeTitle: el.size.title,
                    barcode: el.size.barcode
                }
                if (!res[el.size.barcode]) {
                    res[el.size.barcode] = JSON.parse(JSON.stringify(el))
                }
                else {
                    res[el.size.barcode].countProduct += el.countProduct 
                }
            })
            setData(Object.values(res))
            setTotalUnits(c)
        }
        catch {}
        finally {setLoading(false)}
    }

    useEffect(() => {
        fetchData()
    }, [market]);

    const getMeMyDefects = async () => {
        setLoading(true)
        let cdt = await await get('dndTables/get', {cid:company_id, type: "products_shipment"})
        socket.emit("dnd_change_deal_type", {id: data[0].deal_id, newStatus: cdt[0].status, oldType: 'products_storage', newType: "products_shipment", company_id})
        showNotification({
            id: 'successCreate', 
            type: 'success', 
            message: `Брак успешно переведен в статус отгрузки`
        });
        setData([])
        setLoading(false)
    }

    return (
        <Box sx={{height: '100%', width: "100%"}}>      
            <div style={{
                width: '98%', 
                height: 'calc(85% + 5px)', 
                overflow: 'hidden',
                margin: "0% 1% 1% 1%",
                borderRadius: "10px",
                backgroundColor: 'white'
            }}>
                {loading? <Loading></Loading>:
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderRadius: "10px"}}
                >
                    <ReportTable 
                        ds={ds} 
                        data={sortProducts(data)} 
                    />
                </Scrollbars>
                }
            </div>
        </Box>
    );
}


export function ClientsReturns({type, setInfo, setButtons}) {
    const ds = useMemo(() => getDataSource('ClientsReturns'), []);
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    const [totalUnits, setTotalUnits] = useState(0);
    const { market } = useSelector(MarketClientSelector);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);


    const { user_id  } = useSelector(
        loginSelector
    );

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 10px'}}>
                        SKU: {data.length}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Кол-во: <Typography component="span" sx={{ fontSize: '12pt', color: 'inherit' }}>{totalUnits} шт.</Typography>
                    </Typography>
                </>
            )
        }
        setInfo(getInfo())
    }, [data, totalUnits, type]);

    useEffect(() => {
        const getButtons = () => {
            return (
                <Button 
                    variant="contained" 
                    onClick={() => { setOpenDialog(true) }}
                    sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: "10px" }}
                    disabled={data.length === 0}
                >
                    Обработать
                </Button>
            )
        }
        setButtons(getButtons())
    }, [type, data]);

    const fetchData = async () => {
        try {
            setLoading(true)
            let products = undefined
            switch (type) {
                case "returns": {
                    products = await get('Deal/GetCliStorageProducts', {cid:user_id, market, type: 'returns'});
                    break
                }
                case "selfreturns": {
                    products = await get('Deal/GetCliStorageProducts', {cid:user_id, market, type: 'selfreturns'});
                    break
                }
            }
            let c = 0
            products.map((el) => {
                c += el.countProduct
                el.data = {
                    vendorCode:el.vendorCode,
                    brand:el.data.brand,
                    title:el.data.title,
                    photo:el.data.photo,
                    nmID:el.nmID,
                    color:el.color,
                    barcode: el.size.barcode,
                    sizeTitle: el.size.title,
                }                
                el.countInfo = { count: el.countProduct, inBox: el.inbox, err: false }
                el.storage_count = el.countProduct
            })
            setData(products)
            setTotalUnits(c)
        }
        catch {}
        finally {setLoading(false)}
    }

    useEffect(() => {
        fetchData()
    }, [market]);

    return (
        <Box sx={{height: '100%', width: "100%"}}>    
            <div style={{
                width: '98%', 
                height: 'calc(85% + 5px)', 
                overflow: 'hidden',
                margin: "0% 1% 1% 1%",
                borderRadius: "10px",
                borderTopLeftRadius: type === 'returns'? "0px": "10px",
                backgroundColor: 'white'
            }}>
                {loading? <Loading></Loading>:
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderRadius: "10px"}}
                >
                    <ReportTable 
                        ds={ds} 
                        data={sortProducts(data.filter((fel) => fel.countProduct > 0))} 
                    />
                </Scrollbars>
                }
            </div>
            <Dialog
                open={openDialog}
                // maxWidth='lg'
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenDialog(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    <AddProductToNewDeal
                        data={data}
                        cancel={setOpenDialog}
                        type={type}
                        market={market}
                    >
                    </AddProductToNewDeal>
                </div>
            </Dialog>
        </Box>
    );
}

function AddProductToNewDeal({ data, cancel, type, market }) {

    /** @type {[Array<any>, Function]} */
    const [$data, setData] = useState([]); 
    /** @type {[Array<any>, Function]} */
    const [selected, setSelected] = useState([]); 

    const ds = useMemo(() => getDataSource('ProductsForNewDealReturns'), []);
    const preventDoubleClick = usePreventDoubleClick();
    const navigate = useNavigate();
    const { showNotification } = useLocalNotifications();
    // @ts-ignore
    const { setContextData } = useDataContextDeal();

    const [checked, setChecked] = useState(false);
    
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
        brand: { name: "Брэнд", active: true },
        vendorCode: { name: "Артикул", active: true },
        barcode: { name: "ШК", active: true },
        color: { name: "Цвет", active: true },
    });


    useEffect(() => {
        setData(data.map((el) => ({ ...el })));
    }, [data]);


    const goBind = async () => {
        const res = $data.filter(el => selected.includes(el.id) && el.countProduct > 0);
        if (res.length === 0) return;
        for (let el of res){
            if (el.countProduct > el.storage_count) {
                showNotification({
                    id: 'countFail', 
                    type: 'error', 
                    message: `Вы запросили больше товара, чем есть на складе (${el.size.barcode})`
                });
                return
            }
        }
        setContextData({ deal: res, type, market })
        navigate('deal');
        cancel(false);
    };

    return (
        <Box sx={{ height: '100%', display: "flex", flexDirection: "column", p: 1, gap: 2, overflow: "hidden" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>{ds.descr.title}</Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ width: "75%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked} 
                    // @ts-ignore
                    fields={filterFields} setFields={setFilterFields} />
                </Box>
            </Box>

            <div style={{ display: "flex", flexDirection: 'row', height: "100%", overflow: 'hidden' }}>
                <Box sx={{ 
                    flex: 1, 
                    borderRadius: 2, 
                    overflow: 'hidden',
                    '& tr, & .MuiTableRow-root': { 
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {backgroundColor: '#f5f5f5 !important'}}
                }}>
                    <Scrollbars autoHide>
                        <ReportTable
                            ds={ds}
                            data={!checked ? sortProducts($data) : sortProducts($data.filter((el) => {
                                const tf = filter.toLowerCase();
                                return (
                                    filterFields.title.active &&
                                        el.data.title &&
                                        String(el.data.title).toLowerCase().includes(tf) ||
                                    filterFields.brand.active &&
                                        el.data.brand &&
                                        String(el.data.brand).toLowerCase().includes(tf) ||
                                    filterFields.vendorCode.active &&
                                        el.vendorCode &&
                                        String(el.vendorCode).toLowerCase().includes(tf) ||
                                    filterFields.barcode.active &&
                                        el.size.barcode && 
                                        String(el.size.barcode).toLowerCase().includes(tf)
                                )
                            }))}
                            onSelect={setSelected}
                            inputSelected={selected}
                            onFormatterChange={(idata) => {
                                let tmp = [...$data];
                                let idx = tmp.findIndex((el) => el.id === idata.row.id);
                                if (idx > -1) { tmp[idx].countProduct = idata.count; setData(tmp); }
                            }}
                        />
                    </Scrollbars>
                </Box>
            </div>
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    width: "100%",
                    justifyContent: 'space-between',
                }}
            >
                <Button 
                    onClick={() => cancel(false)}    
                    variant="text" 
                    sx={{ 
                        height: "35px", 
                        width: "150px", 
                        textTransform: 'none', 
                        fontWeight: 'bold', 
                        marginBottom: '10px',
                        marginTop: '10px',
                        fontSize: "20px",
                        borderRadius: "10px"
                    }}
                >
                    {"Отмена"}
                </Button>
                <Button 
                    onClick={preventDoubleClick(goBind, 1000)}
                    variant="contained" 
                    sx={{ 
                        height: "35px", 
                        width: "150px", 
                        textTransform: 'none', 
                        fontWeight: 'bold', 
                        marginBottom: '10px',
                        marginTop: '10px',
                        fontSize: "20px",
                        borderRadius: "10px"
                    }}
                >
                    Добавить
                </Button>
                
            </Box>
        </Box>
    );
}